var _circle, _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 6.875,
    r: 1.875,
    stroke: "#495057",
    strokeWidth: 1.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.75 15H15C15 12.2386 12.7614 10 10 10C7.23858 10 5 12.2386 5 15H6.25C6.25 12.9289 7.92893 11.25 10 11.25C12.0711 11.25 13.75 12.9289 13.75 15Z",
    fill: "#495057"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.25,
    width: 15,
    height: 16.875,
    rx: 4.375,
    stroke: "#495057",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.5e823f4e163be2549cb33f1fafaa4ff7.svg";
export { ForwardRef as ReactComponent };